import {useContext, useState} from "react";
import {
  FaFile,
  FaNewspaper,
  FaPaperclip,
  FaTimes,
  FaUserCircle
} from "react-icons/fa";
import {LoadingContext, ToastContext, UserContext} from "../../contexts";
import {PublicacaoApi} from "../../apis";
import {useNavigate} from "react-router";
import {Switcher} from "../Switcher";
import Logo from "../../assets/img/logo-h.png";

export const ArquivoEditor = ({item, key, update}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const [itemDetalhes, setItemDetalhes] = useState(null);
  const [itemArquivos, setItemArquivos] = useState(null);
  const {user} = useContext(UserContext);
  const [modalDelete, setModalDelete] = useState(false);

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const openArquivo = async () => {
    setLoading(true);
    try {
      let respostaGetItem = await PublicacaoApi.getItem(user.uuid, item.uuid);
      if (!respostaGetItem.error) {
        await setItemDetalhes(respostaGetItem.data.publicacao);
        await setItemArquivos(respostaGetItem.data.arquivos);
        setModalOpen(true);
        setLoading(false);
      } else {
        setLoading(false);
        AddToast({texto: respostaGetItem.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    setLoading(false);
  }

  const toggleStatus = async () => {
    setLoading(true);
    try {
      let respostaStatus = await PublicacaoApi.toggleStatus(user.uuid, item.uuid);
      if (!respostaStatus.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaStatus.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    update();
  }

  const deleteItem = async () => {
    setLoading(true);
    try {
      let respostaDelete = await PublicacaoApi.delete(user.uuid, item.uuid);
      if (!respostaDelete.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaDelete.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    setModalDelete(false);
    update();
  }

  return (
    <div className="arquivo" key={key}>
      <div className="arquivo-item">
        <div className="publicacao-info">
          <span className="data">{item.data}</span>
          <span className="titulo">{item.arquivo &&
            <FaPaperclip title="Há arquivo(s)"/>} {item.titulo}</span>
        </div>
        <div className="opcoes">
          <div className="switch">
            <Switcher checked={item.status} onClick={toggleStatus}/>
          </div>
          <div className="btn btn-cancelar" onClick={openArquivo}>
            <span>Visualizar</span>
          </div>
          <div className="btn btn-editar"
               onClick={() => navigate('/portalcolaborador/publicacao/edit', {state: {propUuid: item.uuid}})}>
            <span>Editar</span>
          </div>
          <div className="btn btn-primary" onClick={() => setModalDelete(true)}>
            <span>Excluir</span>
          </div>
        </div>
      </div>

      {modalOpen &&
        <div className="tela-modal-arquivo">
          <div className="modal-arquivo">
            <div className="modal-arquivo-cabecalho">
              <div className="titulo">
                <FaNewspaper size={30}/>
                <span>Publicação</span>
              </div>
              <div className="btn-close-modal" onClick={() => {
                setModalOpen(false)
              }}>
                Fechar(
                <FaTimes/>
                )
              </div>
            </div>

            <div className="modal-arquivo-informacoes">
              <span className="data">{itemDetalhes.data}</span>
              <h2 className="titulo">{itemDetalhes.titulo}</h2>
              <textarea disabled className="texto">{itemDetalhes.texto}</textarea>
              {itemArquivos.length > 0 &&
                <div className="modal-arquivo-arquivos">
                  {itemArquivos.map((item) => (
                    <a target="_blank" href={item.link} key={item.uuid} className="modal-arquivo-item" rel="noreferrer">
                      <FaFile size={24}/>
                      {item.nome}
                    </a>
                  ))}
                </div>
              }
              {itemDetalhes.visto &&
                <div className="visto">
                  <h3>Visto por:</h3>
                  <div className="pessoas">
                    {itemDetalhes.visto.map((pessoa) => (
                      <div className="pessoa" key={pessoa.uuid}>
                        <div className="avatar">
                          {pessoa.avatar ? <img src={pessoa.avatar} alt={"Avatar de " + pessoa.nome}/> :
                            <FaUserCircle/>}
                        </div>
                        <div className="info">
                          <h4>{pessoa.nome}</h4>
                          <h5>Função: {pessoa.funcao}</h5>
                          <h5>Em: {pessoa.data}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              }
              <div className="modal-arquivo-info-complementar">
                {/*<span><b>Publicado por:</b> "Autor name" em "Criado data"</span>*/}
                {/*<span><b>Ultima alteração por:</b> Sem alterações</span>*/}
                <img src={Logo} alt="Logo"/>
              </div>
            </div>
          </div>
        </div>
      }
      {modalDelete &&
        <div className="modal-delete">
          <div className="delete-box">
            <span>Tem certeza que deseja remover o arquivo?</span>
            <div className="button" onClick={deleteItem}>
              Sim
            </div>
            <div className="button" onClick={() => setModalDelete(false)}>
              Não
            </div>
          </div>
        </div>
      }
    </div>
  );
}